<template>
  <div id="vini">
    <div class="col-lg-12 riserve">
      <img src="../../static/image/products/riserveOmbra.jpg" style="width: 100%; height: auto">
      <div class="test">
        <div class="cit">"Il vino non si beve soltanto, si annusa, si osserva, si gusta, si sorseggia e... se ne parla."</div><br>
        <div class="autore">- Edoardo VII -</div>
        <b-btn class="bottone" :to="{name: 'shop', params:{catVino: 'Riserve'}}">Riserve</b-btn>
      </div>
    </div>
    <div class="col-lg-12 spumanti">
      <img src="../../static/image/products/spumantiOmbra.jpg" style="width: 100%; height: auto">
      <div class="test">
        <div class="cit">"Il vino è un composto di umore e luce"</div><br>
        <div class="autore">- Galileo Galilei -</div>
        <b-btn class="bottone" :to="{name: 'shop', params:{catVino: 'Spumanti'}}">Spumanti</b-btn>
      </div>
    </div>
    <div class="col-lg-12 tradizione">
      <img src="../../static/image/products/tradizioneOmbra.jpg" style="width: 100%; height: auto">
      <div class="test">
        <div class="cit">"Et però credo che molta felicità sia agli homini che nascono dove si trovano i vini buoni."</div><br>
        <div class="autore">- Leonardo da Vinci  -</div>
        <b-btn class="bottone" :to="{name: 'shop', params:{catVino: 'Rossi'}}">Vini Rossi</b-btn>
      </div>
    </div>
    <div class="col-lg-12 bianchi">
      <img src="../../static/image/products/bianchiOmbra.jpg" style="width: 100%; height: auto">
      <div class="test">
        <div class="cit">"Il vino è poesia della terra."</div><br>
        <div class="autore">- Mario Soldati -</div>
        <b-btn class="bottone" :to="{name: 'shop', params:{catVino: 'Bianchi'}}">Vini Bianchi</b-btn>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderPage from "./HeaderPage";
export default {
  name: "Vini",
  components: {HeaderPage},
  updated: function () {
    window.addEventListener('resize', this.getPageHeight)
  },
  mounted: function () {
    scroll(0,0)
  },
  methods: {
    getPageHeight: function (event) {
      this.pageHeight = window.innerHeight
    }
  }
}
</script>

<style lang="less">
  @import "../assets/less/variabili.less";
  @import "../assets/less/font.less";
  #vini {
    .riserve{
      /*background-image: url("../../static/image/products/riserveOmbra.jpg");*/
      /*background-size: cover;*/
      /*padding-top: 300px;*/
      padding-left: 0px;
      padding-right: 0px;
      position: relative;
      .test{
        position: absolute;
        top: 30%;
        padding-left: 100px;
        width: 45%;
        .cit{
          display: inline-block;
          .set-font-Javacom();
        }
        .autore{
          text-align: right;
          .set-font-latoLight(@size: 25px);
        }
        .bottone{
          width: 230px;
          background-color: @myOrange;
          border-color: @borderOrange;
          margin: auto;
          text-align: center;
          display: inherit;
          letter-spacing: 1px;
          margin-top: 40px;
          .set-font()
        }
      }
    }
    .bianchi{
      /*!*background-image: url("../../static/image/products/bianchiOmbra.jpg");*!*/
      /*background-size: cover;*/
      /*padding-top: 300px;*/
      text-align: right;
      /*padding-right: 100px;*/
      padding-left: 0px;
      padding-right: 0px;
      position: relative;
      .test {
        position: absolute;
        top: 30%;
        padding-left: 60%;
        .cit {
          .set-font-Javacom();
        }
        .autore {
          text-align: right;
          .set-font-latoLight(@size: 25px);
        }
        .bottone{
          width: 230px;
          background-color: @myOrange;
          border-color: @borderOrange;
          margin: auto;
          text-align: center;
          display: inherit;
          letter-spacing: 1px;
          margin-top: 40px;
          .set-font()
        }
      }
    }
    .tradizione{
      /*background-image: url("../../static/image/products/riserveOmbra.jpg");*/
      /*background-size: cover;*/
      /*padding-top: 300px;*/
      padding-left: 0px;
      padding-right: 0px;
      position: relative;
      .test{
        position: absolute;
        top: 30%;
        padding-left: 100px;
        width: 45%;
        .cit{
          display: inline-block;
          .set-font-Javacom();
        }
        .autore{
          text-align: right;
          .set-font-latoLight(@size: 25px);
        }
        .bottone{
          width: 230px;
          background-color: @myOrange;
          border-color: @borderOrange;
          margin: auto;
          text-align: center;
          display: inherit;
          letter-spacing: 1px;
          margin-top: 40px;
          .set-font()
        }
      }
    }
    .spumanti {
      /*!*background-image: url("../../static/image/products/bianchiOmbra.jpg");*!*/
      /*background-size: cover;*/
      /*padding-top: 300px;*/
      text-align: right;
      /*padding-right: 100px;*/
      padding-left: 0px;
      padding-right: 0px;
      position: relative;
      .test {
        position: absolute;
        top: 30%;
        padding-left: 45%;
        .cit {
          .set-font-Javacom();
        }
        .autore {
          text-align: right;
          .set-font-latoLight(@size: 25px);
        }
        .bottone {
          width: 230px;
          background-color: @myOrange;
          border-color: @borderOrange;
          margin: auto;
          text-align: center;
          display: inherit;
          letter-spacing: 1px;
          margin-top: 40px;
          .set-font()
        }
      }
    }
  }

  @media (max-width: 1024px) {
    #vini {
      .riserve{
        .test{
          position: relative;
          width: 100%;
          background-color:black;
          padding:50px;
          z-index: 0;
          .cit{
            .set-font-Javacom(@size: 20px);
          }
          .autore{
            .set-font-latoLight(@size: 20px);
          }
          .bottone{
          }
        }
      }
      .bianchi{
        .test {
          position: relative;
          width: 100%;
          background-color:black;
          padding:50px;
          z-index: 0;
          .cit {
            .set-font-Javacom(@size: 20px);
          }
          .autore {
            .set-font-latoLight(@size: 20px);
          }
          .bottone{
          }
        }
      }
      .tradizione{
        .test {
          position: relative;
          width: 100%;
          background-color:black;
          padding: 50px;
          z-index: 0;
          .cit {
            .set-font-Javacom(@size: 20px);
          }
          .autore {
            .set-font-latoLight(@size: 20px);
          }
          .bottone{
          }
        }
      }
      .spumanti{
        .test {
          position: relative;
          width: 100%;
          background-color:black;
          padding: 50px;
          z-index: 0;
          .cit {
            .set-font-Javacom(@size: 20px);
          }
          .autore {
            .set-font-latoLight(@size: 20px);
          }
          .bottone{
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Vini.vue